<div class="flex gap-2 items-center">
  <div
    class="w-full rounded-full bg-gray-200 overflow-hidden"
    [class]="heightClasses()"
    role="progressbar"
    [attr.aria-label]="label()"
    [attr.aria-valuemin]="isIndeterminate() ? null : 0"
    [attr.aria-valuemax]="isIndeterminate() ? null : 100"
    [attr.aria-valuenow]="isIndeterminate() ? null : clampedProgress()">
    @if (!isIndeterminate()) {
      <div
        class="rounded-full h-full transition-all duration-500 ease-in-out"
        [class]="colorClass()"
        [style.width.%]="clampedProgress()"></div>
    } @else {
      <div [class]="colorClass()" class="h-full w-1/2 rounded-full animate-[slide_1.5s_linear_infinite]"></div>
    }
  </div>
  @if (showPercent() && typeof progress() === 'number') {
    <span [class.text-sm]="size() === 'sm'">{{ progress() }}%</span>
  }
</div>
